// import React from "react";
import "./HealthOneNewera.scss";

const HealthOneNewera = () => {
  return (
    <section className="health-one-hero-section">
      <div className="health-one-container">
        <div className="screenshot left">
          <img
            src="https://img.freepik.com/premium-photo/driving-efficiency-healthcare-through-technology_1106454-14849.jpg"
            alt="Left Screens"
          />
        </div>

        <div className="hero-content">
          <p className="health-one-common-parent-sub-heading">
            GET STARTED NOW
          </p>
          <h1 className="health-one-common-black-parent-heading">
            Discover a new era of <br />
            efficiency in healthcare.
          </h1>
          <p className="description">
            Our Medical Dashboard Platform is designed to make healthcare
            management intuitive and efficient.
          </p>

          <div className="email-box">
            <input type="email" placeholder="Your Email Address" />
            <button className="health-one-common-parent-btn">
              Get Started
            </button>
          </div>
        </div>

        <div className="screenshot right">
          <img
            src="https://nividous.com/wp-content/uploads/2022/02/Automation-In-Healthcare-Achieving-Operational-Efficiency-At-Scale-blog-feature-nvd.jpg"
            alt="Right Screens"
          />
        </div>
      </div>
    </section>
  );
};

export default HealthOneNewera;
